import Grid from '@mui/material/Grid';
import { useState } from 'react';
import { Button } from '@mui/material';

import styles from 'assets/css/Hypo.module.css';
import HypoListModal from './HypoListModal';

export const HypoglycemiaReadings = ({ daysAgo,patientId }) => {
  const [modalViewHypoOpen, setModalViewHypoOpen] = useState(false);
  const HypoReadingHandler = () => {
    setModalViewHypoOpen(true);
  };
  return (
    <Grid container className={styles.ButtonContainer}>
      <Button onClick={HypoReadingHandler} className={styles.HypoModalButton}>
        مشاهده هایپوگلیسمی
      </Button>
      <HypoListModal
        open={modalViewHypoOpen}
        setOpen={setModalViewHypoOpen}
        daysAgo={daysAgo}
        patientId={patientId}
      />
    </Grid>
  );
};
